import { render, staticRenderFns } from "./AccountableTransactionsGroupDetailsDialog.vue?vue&type=template&id=12544c32&"
import script from "./AccountableTransactionsGroupDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./AccountableTransactionsGroupDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDialog,VSimpleTable,VTooltip})
